import { literal, union } from 'io-ts/Decoder';

export const Direction = union(literal('asc'), literal('desc'));
